import CarRepairIcon from '@mui/icons-material/CarRepair';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Typography, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import { HomeWrapper, MenuCard, MenuOptions } from './home.styles';
import type { IHomeOption } from './home.types';

const homeOptions: IHomeOption[] = [
  { id: 'upload', label: 'Upload Documents', desc: 'Secure & easy submission tool', icon: <CloudUploadOutlinedIcon />, link: '/upload' },
  { id: 'view-documents', label: 'View Documents', desc: 'View previously submitted documents', icon: <DescriptionOutlinedIcon />, link: '/documents' },
  { id: 'products', label: 'Products', desc: 'Explore available loan products', icon: <CarRepairIcon />, link: '/products' },
];

const HomeView = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const location = useLocation();

  return (
    <Box>
      <Typography fontWeight={700} fontSize={{ xs: 20, sm: 24 }} color="#1a1a1a" mb={1}>
        Welcome to the Hello Refi Hub
      </Typography>
      <Typography fontSize={14} color="#1a1a1a" lineHeight={1.7} mb={{ xs: 3, sm: 4 }}>
      Your Hub is the secure place to upload documents, review important information, and access helpful resources throughout your refinance process.
      </Typography>

      <Typography fontSize={12} fontWeight={600} color="#9aa1ab" mb={1.5} textTransform="uppercase">
        Use the menu to access
      </Typography>

      <MenuOptions>
        {homeOptions.map((item) => (
          <MenuCard key={item.id} onClick={() => navigate(`${item.link}${location.search}`)}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                bgcolor: 'rgba(0,155,142,0.1)',
                color: '#009b8e',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              {item.icon}
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography fontSize={14} fontWeight={600} color={theme.palette.text.primary} lineHeight={1.3}>
                {item.label}
              </Typography>
              <Typography fontSize={12} color={theme.palette.secondary.dark} mt={0.25} lineHeight={1.4}>
                {item.desc}
              </Typography>
            </Box>
            <KeyboardArrowRightIcon sx={{ color: theme.palette.primary.main, ml: 'auto', flexShrink: 0 }} />
          </MenuCard>
        ))}
      </MenuOptions>
      <Typography fontSize={14} color="#1a1a1a" lineHeight={1.7} mt={{ xs: 3, sm: 4 }}>
        Need help? Call us at <a href={'tel:8774355614'} style={{ color: theme.palette.primary.main, fontWeight: 600, marginLeft: '-5px', textDecoration: 'none', cursor: 'pointer' }}>877-435-5614</a>
      </Typography>
    </Box>
  );
};

const Home = () => (
  <HomeWrapper>
    <HomeView />
  </HomeWrapper>
);

export default Home;
